
<template>
    <div>
        <PageComponentCyoSetting/>
    </div>
  </template>
  
  <script setup>
    definePageMeta({
        name: 'cyo-setting-list-ring',
        path: '/ring-settings/:start_with([a-zA-Z-]*[a-zA-Z])?',
        moduleType: 'cyo', 
        moduleSubType: 'ring',
        key: (route) => route.name,
        validate: async (route) => {
			return routeValidation(route)
        }
        // keepalive:true
    })

    onActivated(() => {
        console.log('page -------------- activated')
    // called on component mount
    // and every time it is re-inserted from the cache
    })

    onDeactivated(() => {
        console.log('page deactivaed')

    // called when removed from the DOM into the cache
    // and also when unmounted
    })

  </script>
  